import { useState } from 'react';

/**
 * Custom hook for managing image viewer state
 * Handles opening, closing, and navigating through images
 */
export const useImageManagement = () => {
    const [isImageViewerOpen, setIsImageViewerOpen] = useState(false);
    const [currentViewerImages, setCurrentViewerImages] = useState([]);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    const openImageViewer = (images) => {
        setCurrentViewerImages(images);
        setCurrentImageIndex(0);
        setIsImageViewerOpen(true);
    };

    const closeImageViewer = () => {
        setIsImageViewerOpen(false);
        setCurrentViewerImages([]);
        setCurrentImageIndex(0);
    };

    const nextImage = () => {
        setCurrentImageIndex((prev) => (prev + 1) % currentViewerImages.length);
    };

    const prevImage = () => {
        setCurrentImageIndex((prev) => (prev - 1 + currentViewerImages.length) % currentViewerImages.length);
    };

    return {
        isImageViewerOpen,
        currentViewerImages,
        currentImageIndex,
        openImageViewer,
        closeImageViewer,
        nextImage,
        prevImage
    };
};
